import React from 'react';
import { DownloadLockersBody } from 'zComponents/organisms';
import { Modal } from 'zui/Antd';

const DownloadLockersModal = ({ children, open, setOpen }) => {
	return (
		<Modal open={open} width={1117} centered footer={null} maskClosable onCancel={() => setOpen(false)}>
			<DownloadLockersBody />
		</Modal>
	);
};

export default DownloadLockersModal;
